<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
import Home from '../components/Home'
export default {
    name: 'app',
    components: { Home }
}
</script>

<style>
/*
<BASIC-HTML>
*/
    html, body{
        height: 100%;
        width: 100%;
        margin: 0;
    }

    body{
        background-color: #F8F8FA !important;
        overflow: hidden;
        position: fixed;
    }

    form.file-upload {
        border: none !important;
        padding: 0 !important;
        background-color: transparent !important;
        margin: 4px 0 0 4px;
    }

    form.file-upload input{
        width: 100% !important;
    }

    img{
        display: inline-block;
    }

    body.print-view{
        overflow-y: auto;
        overflow-x: hidden;
    }

    .autocomplete-text, .inline {
        display: inline-block;
        /*width: 100%;*/
    }

    .autocomplete-text, .inline:active, .autocomplete-text, .inline:focus, {
        border: 1px solid transparent !important;
    }

    .mouse-progress{
        cursor: progress !important;
    }

/*
</BASIC-HTML>
*/

/*
<HEADER-MENU-NAVIGATION-TABS>
*/
    /* HEADER */
    .header{
        width: 100%;
        background-color: #323232;
        z-index: 9998;
        color: #FFFFFF;
        height: 40px;
    }

    .logo-container{
        width: 25% !important;
        max-width: 25%;
    }

    .logo-container{
        /* left padding matches #compliance-main's 50px margin so the logo
           lines up with the sidebar's left border */
        padding: 6px 10px 6px 50px;
        height: 100%;
        font-weight: 700;
        color: #fff;
    }

    .logo-container .client-logo{
        float: left;
        height: 20px;
        width: 30px;
        margin-right: 8px;
    }

    .logo-container .client-logo img{
        height: auto;
        width: 30px;
        border-radius: 50px;
    }

    .logo-container .client-name{
        /*float: left;*/
        height: 20px;
        width: 400px;
    }

    .logo-container .client-name .name{
        padding-top: 2px;
    }

    .user-section{
        float: right;
        /* right margin matches #compliance-main's 50px margin so the user
           name lines up with the content's right border */
        margin-right: 50px;
        height: 35px;
        text-align: right;
    }

    /* Responsive mode: #compliance-main uses a 15px margin, so match it. */
    @media screen and (max-width: 1024px){
        .logo-container{
            padding-left: 15px;
        }
        .user-section{
            margin-right: 15px;
        }
    }

    .user-image,
    .user-name {
        display: inline-block;
        position: relative;
        top: 3px;
    }

    .user-image img{
        width: 29px;
        height: 29px;
        margin-top: 3px;
    }

    .user-name span{
        color: #FFFFFF;
        font-size: 16px;
        font-weight: 500 !important;
    }

    .user-name svg{
        position: relative;
        top: 3px;
    }

    .user-logout{
        cursor: pointer;
        display: inline-block;
        padding: 4px 6px 4px 10px;
        width: 100%;
    }

    .user-logout:hover{
        background-color: #585858;
    }

    .user-name .dropdown{
        position: relative !important;
        top: -3px !important;
        background-color: #323232 !important;
    }

    .user-name .dropdown button{
        font-size: 14px !important;
        background-color: #323232 !important;
        color: #FFFFFF !important;
        border: none !important;
    }

    .user-name .dropdown-menu{
        box-shadow: none !important;
        background-color: transparent !important;
        border: none !important;
        z-index: 9999 !important;
    }

    .user-name .dropdown-menu .dropdown-content{
        background-color: #323232 !important;
        border-radius: 0 !important;
        border: none !important;
    }

    .user-name .dropdown-menu .dropdown-content .dropdown-item span{
        color: #FFFFFF !important;
    }

    #user-menu{
        padding:0px;
        margin: 0px;
        right: 0;
    }

    #user-menu .dropdown-content{
        /*left: 8px;*/
        /*width: 100px;*/
        background: #323232 !important;
    }

    #user-menu .dropdown-content .dropdown-item{
        font-size: 14px !important;
        padding: 0px;
        margin: 0px;
        position: absolute;
        right: 11px;
        width: 100px;
        background-color: #323232 !important;
    }

    .user-name span{
        font-weight: bold;
    }

    .profile-image label{
        display: inline-block !important;
    }

    .profile-image .user-image img{
        width: 100px;
        height: 100px;
    }

    .profile-image{
        margin-right: 16px !important;
    }

    .account .button{
        margin-left: 8px !important;
        float: right;
    }

    /* TABS */
    .tabs-container{
        height: 30px;
        margin: 0 40px;
        z-index: 2500;
        line-height: 30px;
    }

    .tabs-container-cp{
        position: relative;
        height: 100%;
        z-index: 2500;
        line-height: 35px;
        /*font-weight: 500;*/
        margin: 35px 40px -3px 40px;
    }

    .tabs-container-cp .is-active{
        background-color: #FFFFFF;
        z-index: 3000;
        border: 1px solid #e3e3e3;
        border-bottom: 1px solid transparent;
    }

    .tab{
        text-align: left;
        padding: 0 10px;
        color: #5B6079;
        font-size: 14px;
        height: 100%;
        display: inline-block;
        position: relative;
    }

    .tab-cp{
        text-align: left;
        padding: 0 10px;
        color: #4e4e4e;
        font-size: 14px;
        height: 100%;
        display: inline-block;
    }

    .tab-cp.is-active{
        box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.025);
    }

    .tab:hover{
        cursor: pointer;
    }

    .tab-active{
        background-color: #FFFFFF;
        z-index: 3000;
        border-left: 1px solid #EEEDEE;
        border-top: 1px solid #EEEDEE;
        border-right: 1px solid #EEEDEE;
        /* box-shadow: 0px -3px 4px rgb(0 0 0 / 10%); */
    }

    .tab-active-cp{
        background-color: #227AE1;
    }

    .tab-active:hover{
        cursor: default;
    }

    .right-tab{
        float: right;
    }

    .right-tab:hover{
        cursor: default;
    }

    .main-error-msg{
        color: #EE0000;
        font-weight: bold;
    }

    .table-msg{
        padding: 7px 16px 6px 0px;
        height: 30px;
        margin: 0px;
        margin-top: 2px;
        margin-right: 10px;
        border-right: 1px solid #E3E3E3;
    }

    .table-msg span{
        font-size: 13px;
        font-weight: normal;
        font-style: italic;
    }



    /* NAVIGATION/SUB MENU */
    .nav{
        color: #FFFFFF;
        display: inline-block;
        vertical-align: top;
        height: 40px;
        z-index: 9998;
        width: 50%;
        text-align: center;
    }

    .nav ul{
        list-style-type: none;
        margin: 0;
        padding-top: 7px ;
        overflow: hidden;
        display: inline-table;
    }

    .nav ul li {
        float: left;
    }

    .nav ul li a {
        display: block;
        color: white;
        text-align: center;
        padding: 5px 10px;
        text-decoration: none;
    }

    .nav ul li{
        display: block;
        color: white;
        text-align: center;
        padding: 3px 12px;
        text-decoration: none;
        top: 0px;
        font-size: 14px !important;
        font-weight: bold;
        margin-left: 10px;
    }

    .nav ul li a:hover{
        background-color: #323232;
        text-decoration: none;
        color: #00CFEF;
    }

    .nav ul li:hover{
        /* background-color: #323232; */
        text-decoration: none;
        /* color: #00CFEF; */
        cursor: pointer;
        background-color: #535353;
    }

    .navbar-item.active{
        /* color: #00CFEF; */
        background-color: #535353;
    }

    .navbar{
        border-radius: 0;
        background-color: #323232;
    }

    .manage-sub-nav{
        background-color: #FFFFFF;
        padding: 4px;
    }

    .clients-sub-nav{
        background-color: #FFFFFF;
        padding: 4px;
    }

    .manage-top-nav .tabs-container, .clients-top-nav .tabs-container{
        height: 32px;
        z-index: 3000;
    }

    .sub-nav{
        padding: 6px 10px 0px 10px;
        position: relative;
        border-bottom: 1px solid #e3e3e3;
        position: fixed;
        background-color: #FFFFFF;
        z-index: 9998 !important;
    }

    .sub-nav, .control{
        font-size: 14px !important;
    }

    .sub-nav ul{
        list-style-type: none;
        margin: 0;
        padding: 0;
        /* overflow: hidden; */
    }

    .sub-nav ul li {
        float: left;
        margin-right: 20px;
        font-size: 14px;
        line-height: 33px;
    }

    .sub-nav ul li.active{
        border-bottom: 3px solid #2776D9;
        color: #2776D9;
    }

    .sub-nav ul li:hover {
        cursor: pointer;
    }

    .sub-nav ul li a {
        display: block;
        color: #000000;
        text-align: center;
        padding: 5px 10px;
        text-decoration: none;
        font-weight: bold;
        font-size: 14px;
    }

    .sub-nav ul li a:hover,
    .sub-nav ul li a.active {
        color: #2776D9;
    }

    .reports-sub-nav ul{
        padding-top: 5px !important;
    }

    .bottom-nav{
        bottom: 12px !important;
        width: 100%;
        height: 45px !important;
        padding-top: 5px;
        border-top: 1px solid #EFEFEF;
    }

    .tab-error{
        text-align: left;
        padding: 0 10px;
        color: #EE0000;
        font-size: 14px;
        height: 100%;
        display: inline-block;

    }


    /* POP UP | DROP DOWN BUTTONS */
    .bottom-nav-btn-group-assign{
        width: 132px !important;
    }

    #dropdown-assign{
        left: -102px;
        width: 132px;
    }

    .bottom-nav-btn-group-save{
        width: 142px !important;
    }

    #dropdown-save{
        left: -112px;
        width: 143px;
    }

    .bottom-nav-btn-group-po{
        width: 122px !important;
    }

    #dropdown-po{
        left: -92px;
        width: 122px;
    }

    .dropdown-menu{
        min-width: unset !important;
    }

    .dropup .dropdown-trigger{
        border-left: 1px solid #ffffff;
    }

    .dropup .dropdown-trigger button{
        border: none !important;
    }

    .dropup .dropdown-trigger button span{
        color: #ffffff !important;
    }

    .bottom-nav-btn-group p a, .dropup .dropdown-trigger button{
        background-color: #9598A6 !important;
    }

    .bottom-nav-btn-group p a:hover, .dropup .dropdown-trigger button:hover{
        background-color: #5a5c61 !important;
    }





    
    

    .dropdown-menu .dropdown-content .dropdown-item ul li, .dropdown-menu .dropdown-content .dropdown-item ul li button{
        width: 100% !important;
    }

    .dropdown-menu .dropdown-content .dropdown-item ul li button{
        background-color: #ffffff;
        border: none;
        border-radius: 0 !important;
    }

    .dropdown-menu .dropdown-content .dropdown-item ul li button:hover{
        background-color: #2D81DE !important;
        color: #ffffff !important;
    }


    .bottom-nav-btn-group, .bottom-nav .dropdown{
        display: inline-flex !important;
    }

    .bottom-nav .dropdown.dropup-save{
        width: 70px !important;
    }

    .bottom-nav .dropdown.dropup-po{
        width: 60px !important;
    }

    .dropdown-button{
        border: 1px solid #3273dc !important;
    }
    
    .dropdown-button:hover > span{
        color: #FFFFFF;
    }

    .dropup .dropdown-trigger button span{
        color: #3273dc;
        
    }
    
    .dropup .dropdown-menu .dropdown-content .dropdown-item{
        padding: 0px !important;
        background-color: #F9F9FA;
    }

    .dropdown-content{
        padding: 0 !important;
        width: 100%;
    }

    .dropdown.is-up .dropdown-menu{
        padding-bottom: unset;
    }

    .save-btn, .new-btn, .po-btn{
        margin-bottom: 5px !important;
        display: block;
    }


    /* REMOVED, REPLACED BY MODAL NOTIFICATION
    .tab-msg {
        text-align: left;
        padding: 0 10px;
        font-size: 14px;
        height: 100%;
        display: none;
    }

    .tab-error{
        color: #EE0000;
    }

    .tab-success{
        color: #228B22;
    }
    */

/*
</HEADER-MENU-NAVIGATION-TABS>
*/


/*
<CONTAINERS-AND-WRAPPERS>
*/
    .page-containers{
        width: calc(100% - 80px);
        max-width: calc(100% - 80px);
        margin-left: 40px;
        margin-right: 40px;
        margin-bottom: 40px;
    }

    .page-containers-cp{
        position: relative;
        margin-top: 1px;
        /*width: calc(100% - 80px);*/
        margin-bottom: 0 !important;

    }

    .home-container{
        padding: 0;
        margin: 0;
        height: calc(100vh - 162px);
        border: 1px solid #E3E3E3;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.10);
    }

    .home-container-cp{
        height: calc(100vh - 200px) !important;
    }

    .div-row{
        height: 100%;
        display: flex;
        padding: 0;
        margin: 0;
    }

    .div-container{
        height: 100%;
        overflow-y: hidden;
        padding: 0;
        margin: 0;
        z-index: 1;
        background-color: #FFFFFF;
        z-index: 2000;
    }

    .title-container{
        padding: 0px 16px;
        margin: 0 40px;
        position: relative;
        height: 60px;
        top: 10px;
        margin-bottom: 20px;
    }

    .title-container-cp{
        background-color: #FFFFFF;
        font-weight: bold;
        margin-top: 15px;
        border: 1px solid #E3E3E3;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.10);
    }

    .page-title{
        left: 0;
        font-weight: bold;
        font-size: 24px;
    }

    .page-functions{
        right: 0;
    }

    .page-title, .page-functions{
        position: absolute;
        height: 30px;
        padding: 10px;
    }

    .main-form, .find-form{
        height: 100%;
        position: relative;
        top: 60px;
        padding: 0 10px;
    }

    .main-form-cp {
        margin: 0 25px;
        top: 60px;
        position: relative;
        padding: 0;
    }

    .manage-main-form{
        top: 30px;
    }

    .find-form{
        top: 10px !important;
        width: auto !important;
        min-width: auto !important;
    }

    .main-form .sub-form,
    .find-form .sub-form {
        padding: 5px;
        overflow-x: hidden;
        overflow-y: hidden;
    }

    .main-form .active,
    .find-form .active{
        display: block;
    }

    .sub-form label{
        font-size: 14px;
        display: block;
        color: #676C83 !important;
    }

    .sub-form label.right-button{
        text-align: right !important;
    }

    .sub-form label.right-button a, .sub-form label.right-button a:hover{
        text-decoration: none;
    }

    .sub-form .inlinelabel{
        font-size: 14px;
        display: inline-block;
    }

    .sub-form .formfield{
        display: block;
    }

    /*
    .sub-form .control input,
    .sub-form .control select {
        font-size: 14px;
    }
    */

    .sub-form-title{
        font-size: 20px;
        font-weight: bold;
    }


    #requests_left,
    #requests_right,
    #vendors_left,
    #vendors_right,
    #manage_left,
    #manage_right,
    #compliance_left, 
    #compliance_right,
    #clients_left, 
    #clients_right,
    #reports_left,
    #reports_right {
        overflow-y: auto;
    }

    #requests_left, #requests_right, #vendors_left, #vendors_right, #compliance_left, #compliance_right, #clients_left, #clients_right, #reports_left, #reports_right, #manage_left, #manage_right {
        padding-left: 0px !important;
        padding-right: 0px !important;
    }

    .manage-table{
        width: 2800px;
    }

    .job-reminders-container, .jobs-not-filled-container{
        margin-top: 10px;
    }


/*
</CONTAINERS-AND-WRAPPERS>
*/

/*
<RESIZER>
*/
    .resizer{
        background-color: #BEBEBE;
        width: 8px;
        position: absolute;
        height: calc(100vh - 162px);
        top: 150px;
        left: 470px;
        padding: 0;
        margin: 0;
        z-index: 9991;
    }

    .resizer-cp{
        background-color: #BEBEBE;
        width: 8px;
        position: absolute;
        height: calc(100vh - 200px);
        top: 0px;
        padding: 0;
        margin: 0;
        z-index: 9991;
    }

    .resizer:hover{
        cursor: ew-resize;
    }

    .resizer-toggle{
        background-color: #227AE1;
        width: 100%;
        height: 50px;
        position: absolute;
        top: calc(50vh - 112px);
        z-index: 9991;
    }

    .resizer-toggle:hover{
        cursor: pointer;
    }



/*
</RESIZER>
*/

/*
<OVERLAYS>
*/
    .overlay{
        padding: 0;
        margin: 0;
        background-color: #000000;
        opacity: 0.8;
        z-index: 9990;
        position: absolute;
        display: none;
        left: 40px;
    }

    .overlay-cp{
        display: visibility !important;
        left: 2px !important;
    }

    .resize-overlay{
        width: calc(100% - 80px);
        height: calc(100vh - 160px);
        overflow-y: auto;
        top: 150px;
    }

    .resize-overlay-cp{
        width: calc(100% - 5px) !important;
        height: calc(100vh - 200px);
        top: 0px !important;
    }

    .table-overlay{
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }

    .table-overlay a{
        position: absolute;
        top: 50%;
        left: calc(50% - 50px);
    }

    .table-overlay .overlay-msg{
        color: #FFFFFF;
        position: relative;
        top: 43%;
        text-align: center;
        width: 100%;
    }

/*
</OVERLAYS>
*/
    /* N.B.: There are scoped styles in the login vue component */
    form{
        border: 1px solid #CCCCCC;
        padding: 30px 48px;
        background-color: #FFFFFF;
    }

    label{
        text-align: left !important;
        padding: 0px !important;
        margin-bottom: 10px !important;
        color: #666B82 !important;
        font-size: 13px;
        font-weight: 600;
    }

    .is-horizontal-center {
        justify-content: center;
    }

    .login{
        margin-top: 100px;
    }

    .login label{
      margin-top: 20px;
    }

    .login.control textarea{
        background-color: #ffffff !important;
    }

    .login form{
        border: 1px solid #e3e3e3;
        box-shadow: 0 2px 4px rgba(0,0,0,.1);
    }

    .top-logo {
        margin-bottom: 30px;
    }

    .field{
        margin-bottom: 0px !important;
    }

    div.field:nth-child(n+2){
        /* margin-top: 25px !important; */
    }

    .login-link{
        width: 100%;
        height: 2.5em;
        background-color: #5179D6 !important;
    }

    .button.is-link.login-link{
        font-size: 18px !important;
        margin: 14px auto !important;
    }

    .password-reset p{
        text-align: center;
    }

    .login .login-input{
        /* background: rgb(250, 250, 250) !important;
        background-color: red !important;
        border: 1px solid red !important; */
    }

    /* .login input[type='text'], input[type='search'], input[type='password']{
        background-color: red !important;
    } */


    .forgot-username:hover{
        cursor: pointer;
        color: #3273dc;
        transition: 0.3s;
    }

    .image img{
        display: block;
        height: auto;
        width: 100%;
    }

    .back-to-login{
        display: block !important;;
        margin: 0 auto !important;;
    }

    .back-to-login:hover{
        cursor:pointer;
        color: #5179D6;
    }

    .control.has-icons-left .input.is-medium ~ .icon, .control.has-icons-left .select.is-medium ~ .icon, .control.has-icons-right .input.is-medium ~ .icon, .control.has-icons-right .select.is-medium ~ .icon{
        font-size: 1.5rem;
    }

    .control.has-icons-left .icon, .control.has-icons-right .icon{
    }

    .reset-heading{
        font-size: 16px;
        font-weight: bold;
        color: #666b82;
        margin-bottom: 8px;
    }


/*
</LOGIN>
*/


/*
<FORM-ELEMENTS>
*/

    .formLabel{
        font-size: 10px;
        display: block;
    }

    .formElement{
        display: block;
    }

    .formElement input, select{
        width: 98%;
        max-width: 98%;
    }

    .short-input{
        width: 60px !important;
    }

    .medium-input{
        width: 200px;
    }

    input[type='text'],
    input[type='search'],
    input[type='password'] {
        box-shadow: inset 1px 1px 3px rgba(0, 0, 0, .18) !important;
        /* match the 4px radius vue-select puts on its dropdown toggle */
        border-radius: 4px !important;
        border: 1px solid #cdcdcd;
        height: 2.5em !important;
        font-size: 14px;

    }

    input[type='search']{
        padding: 3px;
        width: 100% !important;
    }

    /* Readonly fields are display-only (e.g. record ids) — gray them out
       and make them fully inert. user-select:none alone does NOT stop
       text selection inside an <input> in Chrome (it only applies to
       text nodes), so also drop pointer-events. [readonly] (attribute
       presence) also covers bare readonly="". */
    input[readonly]{
        background-color: #EEEEEE;
        color: #888888;
        cursor: default;
        pointer-events: none;
        -webkit-user-select: none;
        user-select: none;
    }

    input[type='search']:focus{
        border: 1px solid #3273DC !important;
    }

    textarea{
        box-shadow: inset 1px 1px 3px rgba(0, 0, 0, .18) !important;
        font-size: 14px !important;
        max-width: 98% !important;
        font-family: Courier New, Courier, Lucida Sans Typewriter, Lucida Typewriter, monospace;
        white-space: pre-wrap; /* Preserve Line Breaks */
        border-radius: 4px !important; /* match the v-select dropdown toggle */
        font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif !important;

        word-break: normal;
        overflow-wrap: break-word !important;
    }

    .textarea-cancel:focus{
        border: 1px solid #F27B6D !important;
    }

    .message-textarea{
        font-size: 16px;
    }

    select {
        /* styling */
        box-shadow: inset 1px 1px 3px rgba(0, 0, 0, .18) !important;
        background-color: white;
        border: thin solid #CCCCCC;
        border-radius: 4px !important; /* match the v-select dropdown toggle */
        display: inline-block;
        font: inherit;
        font-size: 14px !important;
        height: 2.5em;
        line-height: 1.5em;
        padding: 0.3em 3.5em 0.3em 1em;
        outline: 0;

        /* reset */
        margin: 0;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        -webkit-appearance: none;
        -moz-appearance: none;
        color: #000;
        text-shadow: 0 0 0 #000;

        background-image:
            linear-gradient(45deg, transparent 50%, #000000 50%),
            linear-gradient(135deg, #000000 50%, transparent 50%);
        background-position:
            calc(100% - 20px) calc(1em + 1px),
            calc(100% - 15px) calc(1em + 1px);
        background-size:
            5px 5px,
            5px 5px,
            1px 1.5em;
        background-repeat: no-repeat;

    }

    select.minimal {
        background-image:
            linear-gradient(45deg, transparent 50%, gray 50%),
            linear-gradient(135deg, gray 50%, transparent 50%),
            linear-gradient(to right, #ccc, #ccc);
        background-position:
            calc(100% - 20px) calc(0.5em + 2px),
            calc(100% - 15px) calc(0.5em + 2px),
            calc(100% - 3em) 0.1em;
        background-size:
            5px 5px,
            5px 5px,
            1px 3em;
        background-repeat: no-repeat;
    }

    .error-container{
        color: #EE0000;
        display: inline-block;
        margin-left: 10px;
    }

    .msg-container{
        color: #228B22;
        display: inline-block;
        margin-left: 10px;
    }

    .average {
        color: #ffa500;
    }

    .excellent{
        color: #008000;
    }

    .needs_interview{
        color: #800080;
    }

    .poor {
        color: #ff0000;
    }

    .n_a{
        color: #0000ff;
    }


    .section-title{
        font-weight: bold;
        font-size: 18px;
        margin-bottom: 10px;
    }

    .details{
        padding: 20px;
        margin-bottom: 36px;
    }

    .invoice-details{
        padding: 20px !important;
        margin-bottom: 20px;
    }

    .account .details{
        padding: 40px 20px;
    }

    .gray-bg{
        padding: 6px 20px 10px 20px;
        border: 1px solid #E8EBF4;
        background-color: #FBFBFC;
    }

    /*
    .gray-bg label{
        margin-top: 14px !important;
    }
    */

    .gray-bg label {
        margin-top: 8px;
    }

    .gray-bg label, .cancelled-bg label {
        margin-top: 16px;
    }

    div.details.gray-bg div.field:last-child {
        margin-bottom: 20px !important;
    }
    
    .in.progress-bg{
        border: 1px solid #FBEACF;
        background-color: #FFFBF6;
    }

    .cancelled-bg{
        padding: 6px 20px 20px 20px;
        border: 1px solid #FBD8D1;
        background-color: #FFF8F7;
    }

    .scheduled-bg{
        border: 1px solid #CAE6C6;
        background-color: #FBFFFA;
    }

    .completed-bg{
        border: 1px solid #E3EDF9;
        background-color: #f7fafd;
    }

    .white-bg{
        background-color: #FFFFFF;
        padding: 25px;
        margin-bottom: 35px;
    }

    .cancelled-bottom-border{
        padding-bottom: 20px;
        border-bottom: 1px solid #FBD8D1;
    }

    .padded-bottom-border{
        padding-bottom: 20px;
        border-bottom: 1px solid #E8EBF4;
    }

    .padded-bottom{
        padding-bottom: 20px;
    }

    .padded-bottom25{
        padding-bottom: 25px;
    }

    .padded-bottom25.padded-bottom-border{
        padding-bottom: 54px;
    }

    .short-input{
        width: 60px;
    }

    .medium-input{
        width: 200px;
    }

    formElement input{
        max-width: 98%;
    }

    .formfield.is-danger{
        border: 1px solid #FF3860;
    }

    .dot{
      height: 7px;
      width: 7px;
      border-radius: 50%;
      display: inline-block;
    }

    .in-progress{
      background-color: #E79E32;
    }

    .scheduled{
      background-color: #5FA855;
    }

    .cancelled{
      background-color: #D45741;
    }

    .cannot-bill{
      background-color: #4182D7;
    }

    .new-request{
      background-color: #F27B6D;
    }

    .unassigned{
      background-color: #E79E32;
    }

    .pending{
      background-color: #E79E32;
    }

    
    .billed{
      background-color: #888888;
    }
    

    .completed{
      background-color: #4182D7;
    }


    .has-error{
        border: 1px solid #EE0000 !important;
        color: #EE0000 !important;
    }



/*
</FORM-ELEMENTS>
*/



/*
<BUTTONS>
*/

    .function-btn{
        text-align: left;
        padding: 0 20px;
        height: 30px;
        line-height: 30px;
        background-color: #3273dc;
        color: #FFFFFF;
        font-size: 14px;
        display: inline-block;
    }

    .function-btn:hover{
        cursor: pointer;
        background-color: #1d427f;
    }

    .function-btn-outlined{
        height: 30px !important;
    }

    .function-btn a, .function-btn a:hover{
        text-decoration: none;
        color: #FFFFFF;
    }

    .function-btn-disabled{
        cursor: not-allowed !important;
        background-color: #CCCCCC !important;
    }

    .btn-file-upload{
        height: 30px !important;
    }

    .button{
        /* height: 2.5em !important; */
        font-size: 14px !important;
        font-weight: 600;
        letter-spacing: .25px;
        margin: 0;
        border-radius: 3px;
        transition: 0.3s;
        /* padding: 6px 10px; */
    }

    /* Adjacent same-colored buttons (Save / Save & New / New, the page
       function buttons) read as one connected block — give each pair a
       small gap. Attached groups (.field.has-addons) are unaffected:
       their buttons live in separate .control wrappers, so they are
       never adjacent siblings. */
    .button + .button{
        margin-left: 2px;
    }

    /* The page-function controls are divs styled as buttons, so pair them
       up with each other and with real .buttons in the same row. */
    .function-btn + .function-btn,
    .button + .function-btn,
    .function-btn + .button{
        margin-left: 2px;
    }

    .button:hover{
        background-color: #1d427f !important;
    }

    .gray-button, .gray-button:focus, .c-button, .export-button{
        background-color: #9598A6 !important;
        border-color: transparent !important;
        color: #FFFFFF !important;
    }

    .gray-button:hover, .custom-select.c-button:hover{
        background-color: #5A5C61 !important;
    }

    .gray-button:hover{
        color: #FFFFFF;
        border-color: transparent;
    }

    .cancel-buttons{
        padding: 0px 0px 8px 10px;
    }

    .cancel-buttons button{
        margin-left: 4px;
      }

    .cancel-buttons .is-cancel{
        background-color: #D15D48 !important;
        border: 1px solid #D15D48 !important;
        color: #ffffff !important;
        margin-right: 4px;
    }

    .is-cancel, .is-cancel:focus, .is-cancel:hover{
        background-color: #A73C28 !important;
        border: 1px solid transparent !important;
        color: #ffffff !important;
    }

    .v-button {
        min-width: 100px;
    }

    .button.v-button.tertiary-button{
        background-color: transparent;
        border: 1px solid #9598A6 !important;
        color: #9598A6 !important;
    }

    .button.v-button.tertiary-button:hover{
        color: #ffffff !important;
    }

    .c-button{
        width: 120px !important;
        height: 2.25em;
        font-size: 14px !important;
        font-weight: 600;
        letter-spacing: .25px;
        width: 100%;
        margin: 0;
        border-radius: 3px;
    }

    .c-button #drop-down-menu{
        padding-left: 8px;
    }

    .modal-button{
        min-width: 100px;
        font-size: 14px !important;
        border-radius: 3px !important;
        color: #FFFFFF !important;
    }

    .second-button{
        background-color: #9598A6 !important;
        border: 1px solid transparent !important;
    }

    .second-button:hover{
        background-color: #9598A6 !important;
        border: 1px solid transparent !important;
        color: #fff !important;
    }

    .v-request{
        margin-bottom: 30px;
    }

    .info{
        color: #4182D7;
        font-weight: bold;
        width: 30px;
        border-bottom: 4px solid #4182D7;
        padding-top: 3px;
        margin-left: 15px;
        position: relative;
        float: left;
        padding-bottom: 12px;
    }

    .info-buttons{
        float: right;
        margin-right: 16px;
    }

    .info-buttons .c-button{
        height: 2.25em !important;
        padding: 2px 4px 2px 8px !important;
        display: inline-block;
    }

    .info-buttons .c-button:hover{
        transition: 0.3s;
    }

    .info-buttons .dropdown-toggle{
        font-size: 14px;
        font-weight: 600;
        margin-top: 2px !important;
        padding-right: 20px;
    }

    .dropdown-menu, .custom-option{
        border-radius: 0;
    }

    .b-location{
        font-size: 12px !important;
        float: right;
        margin-left: 6px;
        height: 2.25em !important;
        font-size: 14px !important;
    }

    .location-form{
        margin-top: 22px;
    }

    .upload-button{
        color: #737373;
        font-weight: bold;
        background-color: transparent;
        border: 1px solid #9598A6;
        color: #9598A6;
        font-size: 14px !important;
        font-weight: 600;
        letter-spacing: .25px;
        border-radius: 3px;
        transition: 0.3s;
        height: 2.25em !important;
        padding: 2px 8px !important;
        margin: 24px 0px;
    }

    .upload-button:hover{
        background-color: #9598A6 !important;
        color: #ffffff !important;
        border: 1px solid #9598A6 !important;
    }

    #cancel_request_btn{
        margin-top: 26px;
        width: 112px;
    }

    #cancel_request_btn:hover{
        text-decoration: none;
        background-color: #ffffff !important;
        color: #000000;
    }


/*
</BUTTONS>
*/


/*
<IMAGES>
*/
    .user-image img{
        width: 29px;
        height: 29px;
        margin-top: 3px;
        border-radius: 50%;
    }

    .user-profile{
        color: #FFFFFF;
        display: inline-block;
        position: absolute;
        right: 20px;
    }

    .logo{
        /* left padding matches #compliance-main's 50px margin so the logo
           lines up with the sidebar's left border. This rule wins over
           .logo-container (later in the file), so set it here. */
        padding: 5px 10px 5px 50px;
        /* width: 400px !important; */
        margin: 0 auto;
        /* max-width: 400px; */
        height: auto;
    }

    /* Responsive mode: #compliance-main uses a 15px margin, so match it.
       Declared after .logo so it wins on narrow viewports. */
    @media screen and (max-width: 1024px){
        .logo{
            padding-left: 15px;
        }
    }

    .logo-text{
        display: inline-block;
        color: #FFFFFF !important;
        position: relative;
        top: 3px;
        font-family: 'Lato', sans-serif;
    }

    .icon.is-small.is-left{
        height: 100%;
    }



/*
</IMAGES>
*/

/*
<MODALS>
*/
    /* N.B.: There are scoped styles in the modal vue components */
    .modal-rate-agreement{
        white-space: pre;
        margin-top: 20px;
        font-size: 14px;
        overflow-wrap: break-word;
        height: 85%;
        padding: 10px;
    }
    
    .modal-assign-staff{
        width: 95%;
        margin: 0 auto;
    }

    .btn-container{
        position: relative;
        bottom: 0px;
    }

    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
        top: 0 !important;
    }

    .modal-container {
        /* width, height, and padding are scoped */
        margin: 0px auto;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        padding: 0px !important;
        border-radius: 0px;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body, .modal-footer{
        margin: 0px;
        background: #FFFFFF;
    }

    .modal-default-button {
        float: right;
    }

    .modal-message{
        font-size: 16px !important;
    }

    .is-size-4{
        padding-right: 50px !important;
        padding-bottom: 12px;
    }

    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

    .modal-enter-from {
        opacity: 0;
    }

    .modal-leave-to-active {
        opacity: 0;
    }

    .modal-enter-from .modal-container,
    .modal-leave-to-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    .columns:not(:last-child){
        margin-bottom: 0px !important;
    }

    .buttons{
      margin-left: 2px;
    }

    .po-msg{
      padding: 8px;
      margin-bottom: 10px;
    }

    .bg-danger {
      background-color: #DC3545;
      color: #fff;
    }

    .close{
        padding-right: 10px !important;
        font-size: 50px !important;
        font-weight: 300 !important;
        color: #cacaca !important;
        opacity: 1.0 !important;
        margin-top: 0 !important;
    }

    .close:hover{
        color: #cacaca !important;
        opacity: 1.0 !important;
    }


    .close-button {
        margin-top: -40px;
        margin-right: -20px;
    }

    .tabs li a:hover{
        text-decoration: none;
    }

    .tabs:not(:last-child){
        margin-bottom: 0;
    }



/*
</MODALS>
*/

/*
<DATATABLES-OVERRIDE>
*/

.dataTables_wrapper .dataTables_paginate .paginate_button{
    color: #9598A6 !important;
    height: 2.5em !important;
    font-weight: 600 !important;
    letter-spacing: 0.25px !important;
    transition: 0.3s;
    margin: auto 10px;
}
    .dataTables_wrapper .dataTables_paginate .paginate_button:hover{
      border: 1px solid #9598A6 !important;
      background: #ffffff !important;
      color: #9598A6 !important;
    }

    .dataTables_wrapper .dataTables_paginate .paginate_button.disabled{
      color: #9598A6 !important;
    }

    .dataTables_wrapper .dataTables_paginate .paginate_button.disabled:hover{
      color: #9598A6 !important;
      border: 1px solid transparent !important;
    }

    .paginate_page{
      margin-left: 12px;
    }

    .paginate_of{
      margin-right: 12px;
    }

    table {
        table-layout: fixed;
    }

    .dataTable{
        margin: 0 !important;
    }

    .dataTable thead tr th, .dataTable tbody tr td{
        border-left: 1px solid #DDDDDD !important;
        border-right: 1px solid #DDDDDD !important;
        border-top: none !important;
    }

     .dataTable thead tr th{
        border-bottom: 1px solid #ffffff;
     }

     .dataTable tbody tr td{
        border-bottom: 1px solid #DDDDDD !important;
     }

    #vendor-files-table_wrapper .dataTable thead tr th, .dataTable tbody tr td{
        border-top: 1px solid #DDDDDD !important;
    }

    .datatable td {
        overflow: hidden; /* this is what fixes the expansion */
        text-overflow: ellipsis; /* not supported in all browsers, but I accepted the tradeoff */
        white-space: nowrap;
    }

    .dataTable tbody tr td.dt-center{
        text-align: center;
    }

    .dataTable tbody tr td.dt-right{
        text-align: right;
    }

    .dataTable tbody tr.odd{
        background-color: #F7F8FB !important;
    }

    .dataTable tbody tr.even{
        background-color: #FFFFFF;
    }


    .dataTable tbody tr:hover{
        background-color: #D5E3F5 !important;
        color: #4182D7;
    }


    .dataTables_length,
    .dataTables_filter,
    .dataTables_info,
    .dataTables_paginate a,
    .dataTable thead tr th,
    .dataTable tbody tr td {
        font-size: 14px;
    }

    .dataTable tbody tr.row_selected,
    .dataTable tbody tr.row_selected td.sorting_1,
    .dataTable tbody tr.row_selected td.sorting_2,
    .dataTable tbody tr.row_selected td.sorting_3,
    .dataTable tbody tr.selected{
        background-color: #D5E3F5 !important;
        color: #4182D7;
    }


    .dataTable.cell-border tbody tr th:first-child,
    .dataTable.cell-border tbody tr td:first-child {
        border-left: 1px solid #EDEDED;
    }

    .dataTable tbody tr:last-child td{
        border-bottom: 1px solid #DDDDDD;
    }

    .dataTable.cell-border tbody th,
    .dataTable.cell-border tbody td{
        border-right: 1px solid #EDEDED;
    }

    /* override the icons for sorting */
    .dataTable thead .sorting_asc{
        background-image: url('../assets/images/sort_asc.png') !important;
    }

    .dataTable thead .sorting_desc{
        background-image: url('../assets/images/sort_desc.png') !important;
    }

    .dataTables_scrollBody{
        height: 100%;
    }

    .dataTables_wrapper .dataTables_info{
        float: right;
        padding-right: 5px;
    }

    .dataTables_wrapper .dataTables_paginate{
        float: left;
        font-size: 14px;
        color: #000;
    }

    .dataTables_wrapper.no-footer .dataTables_scrollBody {
      border-top: 1px solid #DDDDDD;
    }

    .dataTables_scrollHeadInner{
      border-bottom: 1px solid transparent !important;
    }

    .dataTables_scrollBody .dataTable tbody tr td{
        padding: 2px 5px !important;
    }

    .dataTables_scrollBody .dataTable tbody tr td:first-child{
      border-top: 0;
    }

    .dataTables_scrollHead .dataTable thead tr th {
        height: 39px;
        vertical-align: middle;
        padding: 3px 18px 3px 10px !important;
    }

    #reports_right table thead tr th {
        height: 31px;
        vertical-align: middle;
    }



    #vendor-files-table{
        width: 550px;
    }

    .paginate_input{
        box-shadow: inset 1px 1px 3px rgba(0, 0, 0, .18) !important;
        border-radius: 0px;
        border: 1px solid #cdcdcd;
        height: 2em !important;
        margin: 0px 4px;
        text-align: center;
        width: 40px;
    }

    input.paginate_input{
        font-size: 14px;
    }

    .dt-print-view .dataTable thead tr th{
        border-left: 1px solid #e3e3e3 !important;
        border-right: 1px solid #e3e3e3 !important;
        border-bottom: 1px solid #e3e3e3 !important;
        border-top: 1px solid #e3e3e3 !important;
    }

    .status-cp{
        width: 90px !important;
    }

    .status-cp div{
        padding-left: 10px;
    }

    .last.paginate_button, .first.paginate_button{
        display: none !important;
    }

    .status-cp{
        width: 90px !important;
    }

    .status-cp div{
        padding-left: 10px;
    }

    .last.paginate_button, .first.paginate_button{
        display: none !important;
    }

    table.dataTable thead th{
        border-bottom: none !important;
    }

    .dataTables_wrapper.no-footer .dataTables_scrollBody{
        border-bottom: 1px solid #DDDDDD !important;
    }

    .dt-print-view {
        display: block;
        width: auto;
        height: auto;
        overflow: visible;
        position: absolute;
    }

/*
</DATATABLES-OVERRIDE>
*/

/*
<DATETIME-PICKER>
*/
    /*
    .ui-timepicker{
        z-index: 9999!important;
    }
    */

    .ui-widget, .ui-datepicker table{
        font-size: 14px !important;
        font-family: system-ui, -apple-system, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
    }

    .ui-state-hover, .ui-datepicker-next-hover{
        /*color: #FF0000 !important;*/
    }

    select.ui-datepicker-month, select.ui-datepicker-year{
        font-size: 10px !important;
        padding: 0;
        padding-left: 5px;
        color: #FFFFFF !important;
    }

    select.ui-datepicker-month option, select.ui-datepicker-year option{
        color: #000000 !important;
    }

    .ui-widget-header{
        border-radius: 0 !important;
        border-color: #1d427f !important;
        background: #3273dc !important;
        border: none !important;
    }

    .ui-state-hover{
        border-radius: 0 !important;
        border-color: #3b85ff !important;
        background: #3273dc !important;
        color: #ffffff !important;
    }

    .ui-widget-header a:hover{
        color: #3b85ff !important;
    }

    .ui-state-default{
        color: #4a4a4a !important;
        text-align: center !important;
        border: none !important;
        font-weight: 400 !important;
    }

    .ui-state-default:hover{
        color: #ffffff !important;
        background: #3b85ff !important;
    }

    .ui-state-default.ui-state-active{
        border: 1px solid #3273dc !important;
        color: #3273dc !important;
    }

    .ui-state-default.ui-state-active:hover{
        color: #ffffff !important;
    }

    .ui-state-highlight{
        background: #3b85ff !important;
        color: #ffffff !important;
        /* border: 1px solid #3b85ff !important; */
    }

    .ui-datepicker, .ui-timepicker, .ui-timepicker-minutes, .ui-timepicker-hours{
        /* z-index: 9995 !important; */
        z-index: 99999 !important;
        background: #F9F9FA !important;
    }

    .ui-timepicker-table{
        width: auto !important;
        z-index: 9999;
    }

    .ui-state-default.ui-state-active{
        color: #ffffff !important;
        background: #3b85ff !important;
        border: 0px !important;
    }

    .ui-timepicker-hour-cell{
      text-align: center !important;
    }

    .ui-datepicker-calendar, .ui-widget.ui-widget-content{
        background: #F9F9FA !important;
        border-radius: 0px !important;
    }

    .ui-timepicker-table td{
        min-width: 2.2em;
    }

    .ui-timepicker-table td a{
        width: 100% !important;
    }

    .datepicker input{
        height:20px;
        width:80px;
        padding: 2px;
    }

    .hasDatepicker:focus, .hasDatepicker:active{
        border: 1px solid #3273DC !important;
        outline: none;
    }

    .hasTimepicker:focus, .hasTimepicker:active{
        border: 1px solid #3273DC !important;
        outline: none;
    }

    .ui-datepicker{
        width: 15em;
    }

    .ui-datepicker-prev .ui-corner-all{
        border: 0px solid transparent !important;
    }

    .ui-datepicker-prev.ui-corner-all.ui-state-hover.ui-datepicker-prev-hover{
        border: 0px solid transparent !important;
    }

    .ui-datepicker .ui-datepicker-prev, .ui-datepicker .ui-datepicker-next{
        border: 0px solid transparent !important;
    }

    .ui-widget-header .ui-icon, .ui-icon, .ui-widget-content .ui-icon {
        background-image: url('../assets/images/jqueryui_icons_256x240.png') !important;
    }

    .ui-widget-header a:hover {
        border: none !important;
    }

    .ui-datepicker .ui-datepicker-next-hover{
        right: 2px !important;
        top: 2px !important;
    }

    .ui-datepicker .ui-datepicker-prev-hover{
        left: 2px !important;
        top: 2px !important;
    }

    /*
    .ui-datepicker table{
        font-size: 0.7em;
    }

    */


/*
</DATETIME-PICKER>
*/


/*
<V-SELECT>
*/

    ul.dropdown-menu li a:hover, ul.dropdown-menu li.highlight a{
        background-color: #d5e3f5 !important;
        color: #4182d7 !important;
        width: 100% !important;
        /* background-color: red !important; */
    }

    .dropdown{
        width: 100% !important;
        font-family: Helvetica, Arial, sans-serif;
        display: block;
    }

    .dropdown-menu{
      /* border: 1px solid #E3E3E3; */
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.10);
      border-radius: 0px !important;
    }

    .dropdown-menu div{
        display: block !important;
    }

    .custom-select .dropdown div:nth-child(1), .custom-select .dropdown div:nth-child(2){
        display: inline-block;
    }

    .dropdown-menu{
      /* border: 1px solid #E3E3E3; */
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.10);
      border-radius: 0px !important;
    }

    .dropdown-menu div{
        display: block !important;
    }

    .custom-select .dropdown div:nth-child(1), .custom-select .dropdown div:nth-child(2){
        display: inline-block;
    }

    .dropdown-menu li a{
        font-size: 14px !important;
    }

    .v-select.searchable .dropdown-toggle{
        width: 100%;
    }

    .v-select .dropdown-toggle{
        background-color: #ffffff;
        border: 1px solid #cdcdcd !important;
    }

    .v-select.dropdown ul li{
        width: 100%;
        background-color: #FFF;
    }

    .v-select.dropdown ul li a{
        width: 100%;
        text-align: left;
        font-weight: normal;
    }

    .v-select .dropdown-toggle .selected-tag{
        padding-top: 3px;
        padding-left: 10px;
    }

    .v-select input[type=search], .v-select input[type=search]:focus{
        background: #ffffff !important;
    }

    .dropdown-toggle{
        border-radius: 0px !important;
    }

    .dropdown-toggle:active, .dropdown-toggle:focus {
        border: 0px solid transparent !important;
    }

    .v-select .selected-tag {
        font-size: 14px;
        position: absolute;
        margin: 2px 1px 0 0 !important;
        z-index: 9980 !important;
        padding: 1px 1.25em 1px .25em !important;
        overflow: hidden;
        max-width: 85%;
    }

    .v-select input[type=search],
    .v-select input[type=search]:focus{
        font-size: 14px !important;
        /* height was for the vue-select 2.x fork's DOM (the search input WAS
           the control); vue-select 4 sizes the .vs__dropdown-toggle instead */
        border-radius: 0 !important;
    }

    .v-select .dropdown-menu {
        z-index: 9990 !important;
    }

    .v-select .dropdown-toggle .clear {
        /*visibility: hidden !important;*/
    }

    .dt-buttons{
        display: none;
    }


/*
</V-SELECT>
*/


/*
<CUSTOM-DROP-DOWN>
*/
    .custom-select{
        padding: 5px;
        border: thin solid #CCCCCC;
        background-color: #F9F9FA;
    }

    .custom-select.export-button {
        border-radius: 3px !important;
        width: 125px;
        transition: 0.3s;
        height: 2.25em;
        padding-left: 16px;
        display: block;
    }

/* Options button dropdown menu */
    .info-buttons .custom-select .dropdown-menu{
        color: #4a4a4a;
        min-width: 6.25rem;
        margin: 5px 0 0 -9px;
    }

/* Export button dropdown menu */
    .find-buttons .custom-select .dropdown-menu{
        min-width: 7.25em !important;
        overflow: hidden;
        margin: 5px 0px 0px -17px !important;
    }

    .find-buttons .custom-select .dropdown-menu div{
        display: block;
        width: 100%;
    }

    .export{
        width: 145px;
    }

    .export-button{
        width: 150px;
        background: transparent !important;
        color: #9598A6 !important;
        border: 1px solid #9598A6 !important;
        font-weight: 600;
        letter-spacing: 0.25px;
    }

    .export-button:hover{
        color: #ffffff;
        background: #9598A6 !important;
    }

    .export-button .custom-option{
        color: #4a4a4a;
        font-weight: 400;
        font-size: 14px;
        /* padding: 5px 0px 5px 15px; */
    }

    .find-buttons{
        display: inherit !important;
        margin-top: 36px !important;
    }

    .find-buttons div{
        margin-right: 8px;
    }

    .custom-caret{
        display: inline-block;
        width: 0;
        height: 0;
        vertical-align: middle;
        border-top: 5px dashed;
        border-right: 5px solid transparent;
        border-left: 5px solid transparent;
    }

    .export-button #drop-down-menu{
        margin-top: -1px !important;
    }

    #drop-down-menu{
        width: calc(100% - 32px);
        margin-top: 0px;
        padding-left: 3px;
        letter-spacing: .25px;
    }

    .tertiary-button, .tertiary-button:focus{
        background-color: transparent;
        border: 1px solid #9598A6 !important;
        color: #9598A6 !important;
    }

    .tertiary-button:hover{
        background-color: #9598A6 !important;
        color: #ffffff !important;
        border: 1px solid #9598A6 !important;
    }

    .button:focus:not(:active), .button.is-focused:not(:active){
        box-shadow: 0 0 0 0.125em rgba(50, 115, 220, 0.0) !important;
    }

    .gray-button:focus:not(:active), .gray-button.is-focused:not(:active){
        box-shadow: 0 0 0 0.125em rgba(50, 115, 220, 0.0) !important;
    }

    .tertiary-button:focus:not(:active), .tertiary-button.is-focused:not(:active){
        box-shadow: 0 0 0 0.125em rgba(50, 115, 220, 0.0) !important;
    }

    .custom-option{
        /* padding: 5px 0px 5px 15px; */
        padding: 5px 5px 5px 5px;
        font-weight: 400;
        font-size: 14px;
        /* width: 132px !important; */
        width: 100%;
    }

    .custom-select:hover{
        cursor: pointer;
    }

    .requester-dropdown, .status-dropdown{
        /*width: 163px;*/
        width: 100%;
    }

    .stats-dropdown{
        width: 126px;
        font-weight: 400;
        font-size: 14px;
    }

    .requester-dropdown .dropdown-menu, .status-dropdown .dropdown-menu, .stats-dropdown .dropdown-menu{
        border-radius: 0;
        margin: 5px 0 0 -6px;
        background-color: #F9F9FA;
        overflow-y: scroll;
        min-width: 5rem !important;
        width: calc(100% + 12px);
    }

    .requester-dropdown .dropdown-menu{
        min-height: 70px;
        max-height: 165px;
    }

    .status-dropdown .dropdown-menu{
        height: 165px;
        overflow: hidden;
    }

    .stats-dropdown .dropdown-menu{
        z-index: 20000 !important;
        overflow: hidden;
    }

    .export-button .dropdown-menu{
        border-radius: 0;
        margin: 5px 0 0 -6px;
        width: 8.75em;
        background-color: #F9F9FA;
    }

    .custom-select .dropdown, #user-menu .dropdown{
        width: 100% !important;
        font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
    }

    .custom-select .dropdown-menu div:hover{
        background-color: #D5E3F5;
        color: #4182D7;
    }


/*
</CUSTOM-DROP-DOWN>
*/




/*
<PAGE-SPECIFIC>
*/

    /* REQUEST REMARKS */
    .remark-counter-container{
        display: inline-block;
        color: #FFFFFF;
        font-size: 14px;
        margin-left: 3px;
        text-align: center;
        vertical-align: middle;
        position: relative;
        line-height: 20px;

    }

    .remark-counter-container:hover{
        color: #FFFFFF;
    }

    .remark-ctr{
        width: 20px;
        height: 20px;
        border-radius: 20px;
    }

    .remark-ctr-danger{
        background-color: #F27B6D;
    }

    .remark-ctr-warning{
        background-color: #F3AD45;
    }

    .remark-ctr-compliment{
        background-color: #05AA10;
    }




    /* JOB REMINDERS */
    .job-reminders-top-nav{
        font-size: 14px !important;
    }

    .job-reminders-top-nav input{
        height: 20px;
        width: 80px;
        padding: 2px;
        font-size: 14px;
    }

    .job-reminders-top-nav select{
        height: 2.5em;
        width:180px;
        padding: 2px;
        font-size: 14px;
        color: #4a4a4a;
     }

    .confirmation{
        margin-left: 20px;
    }

    .confirmation span{
        font-weight: bold;
    }

    .top-nav{
        position: relative;
    }

    .top-nav ul{
        list-style-type: none;
        margin: 0;
        padding: 0;
        overflow: hidden;
    }

    .top-nav ul li {
        float: left;
        margin-right: 1px;
    }

    /*
    .top-nav ul li:hover{
        background-color: #00B2EB;
    }
    */

    .top-nav ul li a {
        display: block;
        color: #000000;
        text-align: center;
        padding: 5px 10px;
        text-decoration: none;
        font-weight: bold;
        font-size: 14px;
    }

    .top-nav ul li a.active {
        background-color: #227AE1;
    }


    /* JOBS NOT FILLED */
    .jobs-not-filled-top-nav{
        font-size: 14px !important;
    }

    .confirmation{
        margin-left: 20px;
    }

    .confirmation span{
        font-weight: bold;
    }

    .jobs-not-filled-top-nav input{
        height: 20px;
        width: 80px;
        padding: 2px;
        font-size: 14px;
    }







    /* JOB REMINDERS AND JOBS NOT FILLED */
    .minimal input[type=search],
    .minimal input[type=search]:focus{
        font-size: 14px;
        height:20px;
        border-radius: 0 !important;
        top: -3px;
        margin: 4px 1px 0 3px;
        padding: 0;
        line-height: 15px;
    }

    .minimal .selected-tag{
        border-radius: 0 !important;
        margin:4px 1px 0 3px;
        padding: 0;
        line-height: 15px;
        height: 20px;
    }

    .minimal .open-indicator{
        bottom: -3px !important;
    }
    .minimal.open .open-indicator{
        bottom: -7px !important;
    }

    .minimal .dropdown-toggle .clear{
        bottom: 0;
    }

    /* ul.dropdown-menu li a{
        padding: 4px 10px;
    }

    ul.dropdown-menu li a:hover{
        background-color: red;
    } */


/*
<TOOLTIP>
*/
/* Tooltip container */
    .is-bundled {
        position: relative;
        display: inline-block;
    }
    /* Tooltip text */
    .is-bundled .tooltiptext {
        visibility: hidden;
        width: 120px;
        background-color: #555;
        color: #fff;
        text-align: center;
        padding: 5px 0;
        border-radius: 3px;

        /* Position the tooltip text */
        position: absolute;
        z-index: 1;
        top: 125%;
        left: 57%;
        margin-left: -50px; /* Use half of the width (120/2 = 60), to center the tooltip */

        /* Fade in tooltip */
        opacity: 0;
        transition: opacity 0.3s;
    }

    /* Tooltip arrow */
    .is-bundled .tooltiptext::after {
        content: " ";
        position: absolute;
        bottom: 100%;  /* At the top of the tooltip */
        left: 50%;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: transparent transparent #555 transparent;
    }

    /* Show the tooltip text when you mouse over the tooltip container */
    .is-bundled:hover .tooltiptext {
        visibility: visible;
        opacity: 1;
    }


/*
</PAGE-SPECIFIC>
*/


/*
<CLIENT-STATISTICS>
*/


.orange{
    color: #E79E32;
}

.green{
    color: #5FA855;
}

.red{
    color: #D15741;
}

.blue{
    color: #4182D7;
}

.first-item{
    margin: 15px 0px 25px 20px;
    width: 100px;
    /*padding-left: 20px;*/
}

.request-title{
    margin: 15px 0px 25px 20px;
    min-width: 125px;
}

.new{
    /* height: 32px !important;
    font-size: 12px !important; */
}

.title-buttons{
    margin: 12px 20px !important;
    float: right;
}

.is-stats{
    width: 20%;
    padding: 0.75rem 0;
}

.is-stats span{
    font-size: 18px;
}

.add-new{
    float: right;
    padding-left: 15px;
}

.filter{
    padding-right: 15px;
    height: 35px;
    margin: 25px 10px 0px 20px;
}

select{
    width: 125px;
    font-size: 12px !important;
    font-weight: 400 !important;
    color: #4a4a4a !important;
    background-color: #f9f9fa;
}


@media screen and (min-width: 1025px){
    .client-numbers{
        font-size: 14px;
    }

    .client-options{
        font-size: 12px;
    }

    .first-item{
        border-right: 1px solid #e3e3e3;
    }
}

@media screen and (max-width: 1175px){
    .first-item{
        border-right: 0;
    }
}

@media screen and (max-width: 1024px){
    .client-numbers{
        font-size: 12px;
    }

    .client-options{
        font-size: 10px;
    }

    .first-item{
        border-right: none;
    }

    .request-title {
        margin: 15px 10px 25px 20px;
        min-width: 100px;
    }
}

@media screen and (max-width: 768px){
    .title-container{
        position: relative;
        background-color: #FFFFFF;
        border: 1px solid rgba(0, 0, 0, 0.15);
       -webkit-box-shadow: none;
        box-shadow: none;
        font-weight: bold;
    }

    .tabs-container, .page-containers{
        display:none;
    }

    .client-numbers{
        font-size: 24px;
    }

    .first-item{
        border-right: none;
        width: 100%;
    }

    .title-buttons{
        margin: 0;
        float: left;
        width: 100%;
    }

    .request-title, .first-item{
        min-width: 0;
        margin: 0;
    }

    .request-title, .first-item{
        text-align: center;
    }

    .is-stats{
        width: 100%;
    }

    .is-stats span{
        font-size: 24px;
    }

    .add-new, .filter{
        margin: 0;
        padding: 0;
        float: none;
        width: 100%;
    }
}

/* hide user's image */
@media screen and (max-width: 500px){
    .home{
        margin: 0;
        padding: 0;
    }
    .user-section{
        display:none;
    }
}

.title-left{
    height: 100%;
    padding: 30px;
    margin-top: 0px !important;
}



/*
</CLIENT-STATISTICS>
*/




/*
<REQUEST-INFO>
*/

.requests-sub-nav {
    /*width: inherit;*/
    /* height: 50px; */
    display:inline;

    /*width: auto !important;*/
    /*min-width: auto !important;*/
}

.requests-info .request-notes{
    font-size: 14px !important;
    font-style: italic;
    margin: 12px auto 36px auto;
}



/*
</REQUEST-INFO>
*/













/*
<NOT-IN-USE>
*/

    /*
    .custom-combobox {
        position: relative;
        display: inline-block;
    }

    .custom-combobox-toggle {
        position: absolute;
        top: 0;
        bottom: 0;
        margin-left: -1px;
        padding: 0;
    }

    .custom-combobox-input {
        margin: 0;
        padding: 5px 10px;
    }

    .ui-widget-content.ui-autocomplete{
        z-index: 9999;
    }

    .ui-state-default{
      background-color: #FFFFFF;
    }


    .container-inspector, .container-data-table{
        padding: 0;
    }

    */

/*
</NOT-IN-USE>
*/

</style>
